import React from "react"
import { Button, ClickAwayListener, Popper } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { getLocaleJaOrEn } from "locale.js"
import LanguageIcon from "@material-ui/icons/Language"
import ClearIcon from "@material-ui/icons/Clear"
import { FormattedMessage } from "react-intl"
import LanguageSwitchList from "organisms/LanguageSwitchList"

const useStyles = makeStyles(theme => ({
  menuBox: {
    [theme.breakpoints.down("sm")]: {
      width: "70px",
      height: "60px",
    },
    position: "relative",
    width: "140px",
    height: "60px",
  },
  languageIcon: {
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      top: "-2px",
      left: "25px",
      width: "18px",
    },
    position: "absolute",
    top: "6px",
    left: "12px",
    width: "20px",
  },
  localeButton: {
    position: "absolute",
    top: "12px",
    left: "0",
    width: "130px",
    minWidth: "130px",
    padding: "6px 16px",
    borderRadius: "unset",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      minWidth: "70px",
      width: "70px",
      height: "40px",
      padding: "20px 0 0",
    },
  },
  localeButtonLabel: {
    textTransform: "none",
    padding: "0 0 0 28px",
    textAlign: "left",
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      padding: "2px 0 0",
      fontSize: "12px",
      textAlign: "center",
    },
  },
  localeFormattedText: {
    textTransform: "none",
  },
  popper: {
    zIndex: "10",
    borderRadius: "unset",
  },
}))

const LanguageSwitch = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const nowLocale = getLocaleJaOrEn()
  const handleLocaleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }
  const handleLocaleClose = () => {
    setAnchorEl(null)
  }

  const languageIcon = anchorEl ? (
    <ClearIcon className={classes.languageIcon} />
  ) : (
    <LanguageIcon className={classes.languageIcon} />
  )
  const popperTrans = ({ TransitionProps }) => {
    return (
      <LanguageSwitchList
        nowLocale={nowLocale}
        TransitionProps={TransitionProps}
        handleLocaleClose={handleLocaleClose}
      />
    )
  }
  return (
    <ClickAwayListener
      touchEvent="onTouchStart"
      mouseEvent="onMouseDown"
      onClickAway={handleLocaleClose}
    >
      <div className={classes.menuBox}>
        <Button
          id="localeButton"
          aria-controls="selectLocale"
          aria-haspopup="true"
          onClick={handleLocaleClick}
          className={classes.localeButton}
          classes={{ label: classes.localeButtonLabel }}
        >
          {languageIcon}
          <span className={classes.localeFormattedText}>
            <FormattedMessage id="LanguageSwitch.Locale" />
          </span>
        </Button>
        <Popper
          id="selectLocale"
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          transition
          disablePortal
          className={classes.popper}
        >
          {popperTrans}
        </Popper>
      </div>
    </ClickAwayListener>
  )
}

export default LanguageSwitch
